// Fallback interview questions when AI generation fails
// These are universal questions that work for any job position

export const fallbackInterviewQuestions: string[] = [
  "Tell me about yourself and your professional background.",
  "What are your greatest strengths and how do they help you in your work?",
  "Describe a challenging situation you faced at work and how you handled it.",
  "Where do you see yourself professionally in the next five years?",
  "Why are you interested in this position and what can you bring to our team?",
];

export const fallbackEvaluation = {
  score: 5,
  relevance: "Unable to evaluate answer content due to service unavailability. Your pronunciation has been analyzed.",
  strengths: [
    "You provided an answer to the question",
    "Continue practicing to improve your speaking skills",
  ],
  improvements: [
    "Try to structure your answers using the STAR method (Situation, Task, Action, Result)",
    "Include specific examples from your experience",
  ],
  sampleAnswer: undefined,
};

// Messages for fallback scenarios
export const fallbackMessages = {
  questionsGeneration: "We're using general interview questions because our AI service is temporarily unavailable. Don't worry - you can still practice your pronunciation and speaking skills!",
  answerEvaluation: "AI evaluation is temporarily unavailable, but your pronunciation has been analyzed. Focus on speaking clearly and confidently!",
  transcription: "We couldn't process your audio. Please check your microphone and try again, or try speaking more clearly.",
};
